export const RAW = 'raw';
export const FREQUENCY = 'frequency';
export const CONTINGENCY = 'contingency';
export const RELATIVE_FREQUENCY = 'relative_frequency';


export const radioGroup = [
  {
    labelText: 'Raw dataset (unsummarized observations)',
    value: RAW
  },
  {
    labelText: 'Frequency table (summary of one categorical variable)',
    value: FREQUENCY
  },
  {
    labelText: '2-way contingency table (summary of two categorical variables)',
    value: CONTINGENCY
  }
];
